import {Component, Inject, Input} from 'ng-metadata/core';

@Component({
    "selector": "prm-ngrs-brief-result-Line",
    templateUrl: 'components/search/fullView/ngrs/ngrsBriefResultLine/ngrsBriefResultLine.html'
})

export class PrmNgrsBriefResultLine{

    @Input() item:Object;
    private _offerFound: Object; 
    private _display: Object;


    constructor (){  
            
    }

    ngOnInit(){
        this._offerFound={offerFound:true};
        this._display={display:'display:none'};
    }

    public offerFound(){
        return this._offerFound.offerFound;
    }

    public display(){
        return this._display.display;
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrsBriefResultLine/ngrsBriefResultLine.directive.ts